import axios from "axios";

const createRole = (params) => axios.post("roles/create", params);

export { createRole };
